export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8779.8bbf7b9b.jpg";